import { AnalyticsClient } from './internal';

const client = new AnalyticsClient();

export default client;
